import React, { useEffect } from 'react';
import { StyledFeaturedCarousel } from './StyledFeaturedCarousel';
import { useLocation,useHistory } from 'react-router-dom';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

SwiperCore.use([Navigation]);

const FeaturedCarousel = ({ featuredData, isArticle, titleSection, subtitle, route }) => {

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }
  useEffect(()=>{
    
  },[])
  return (
    <React.Fragment>
      {
       
          <StyledFeaturedCarousel isArticle={isArticle}>
            <div className="paragraph--col-wrap">
              <div className="paragraph--col-big">
                <h6 className="big--title">
                {
                  !isArticle ?
                  titleSection
                  :
                  'Related articles'
                }
                </h6>
              </div>
              {
                !isArticle &&
                <div className="paragraph--col-small">
                  <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick(`/news/category/${route}`)} > 
                    <p className="preset-10 cursor-cta">View all</p>
                    <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                  </div>
                </div>
              }
            </div>
            <div className="paragraph--col-wrap">
              <div className="paragraph--col-big">
                <p className="preset-9">
                  {
                    !isArticle 
                      ?
                      subtitle
                      :
                    'Discover more ways we’re disrupting every industry we get our hands on.'
                  }
                </p>
              </div>
            </div>
            <Swiper 
              
              spaceBetween={0}
              className="carousel-featured"
              navigation
              onReachEnd={(swiper) => swiper.snapGrid = [...swiper.slidesGrid]}
              breakpoints={{
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                  },
              }}
              >
                {

                  featuredData.slice(0, 5).map((key, index) => {
                    return  <SwiperSlide key={index}>
                              <div className="">
                              <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${key.category}`)}>{key.category}</p>
                                <h6 className="big--title" onClick={() => handleCLick(`/news/${key.slug}`)}>{key.title}</h6>
                                <div className="details-wrapper">
                                  <div className="detail-col">
                                    <img src="/calendar-date.svg" />
                                    <p className="preset-12">{key.date}</p>
                                  </div>
                                  <div className="detail-col">
                                    <img src="/time.svg" />
                                    <p className="preset-12">{key.reading_time} min read</p>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                  })
                  
                }
              </Swiper>
            
          </StyledFeaturedCarousel>
          
      }
    </React.Fragment>
  );
};

export default FeaturedCarousel;

FeaturedCarousel.propTypes = {

};
FeaturedCarousel.defaultProps = {
  subtitle: 'See for yourself how we’re disrupting every industry we touch and why we’re worth talking about:'
}